export const isBuilderEditing = (() => {
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.get('__builder_editing__') === 'true'
})()
